import StorageUtil from "@/utils/StorageUtil";
import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";
import md5 from "js-md5";

export default {

    getCheckPhone(mobile) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/login/semiLogin/c_checkPhone.gson', null, {
                params: {
                    customerPhone: mobile,
                }
            }).then(function (response) {
                const rs = response.data;
                if (!("success" in rs)) rs.success = rs.code === 200;
                if (!("result" in rs)) rs.result = rs.data;
                if (rs.success) {
                    resolve({response: response, success: rs.success});
                } else {
                    resolve({response: response, success: rs.success});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    getCaptcha(mobile) {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/captcha/login/' + mobile, {
                params: {}
            }).then(function (response) {
                const rs = response.data;
                resolve({response: response, success: rs.code === 200});
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    getUserInfo() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/customer/info', {})
                .then(function (response) {
                    const rs = response.data;
                    if (!("success" in rs)) rs.success = rs.code === 200;
                    if (!("result" in rs)) rs.result = rs.data;
                    SessionUtil.setUserData(rs.data);
                    resolve({response: response, success: rs.success});
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    login(mobile, captchaId, captcha) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/login/captcha', {
                phone: mobile,
                captchaId: captchaId,
                captchaValue: captcha,
                loginDeviceType: "LDT0001",
                appVersion: config.versionName,
            }, {}).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    SessionUtil.setUserToken(rs.data);
                    resolve(rs);
                } else {
                    resolve(rs);
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}